<template>
  <div
    class="call-screen outgoing"
    :class="{accepted: contact.callstatus === 'accepted'}"
  >
    <div class="container">
      <h5 v-if="noAnswer">
        {{ $t('APP_TEXT_NO_ANSWER') }}
      </h5>
      <h5 v-else-if="contact.callstatus === 'accepted'">
        {{ $t('APP_TEXT_ACCEPTED') }}
      </h5>
      <h5 v-else-if="contact.callstatus === 'rejected'">
        {{ $t('APP_TEXT_REJECTED') }}
      </h5>
      <h5 v-else-if="contact.callstatus === 'end'">
        {{ $t('APP_TEXT_CALL_END') }}
      </h5>
      <h5 v-else-if="contact.callstatus === 'locked'">
        {{ $t('APP_TEXT_REJECTED_ROOM_LOCKED') }}
      </h5>
      <h5 v-else>
        {{ $t('APP_TEXT_CALLING') }}
      </h5>
      <!-- User Card Tile -->
      <div class="error-icon">
        <svg-icon icon="SvgCloseStroke" />
      </div>
      <ContactLiteCard
        :contact="contact"
        :animate="showControls"
      />
      <h4>{{ contact.name }}</h4>
      <p
        v-if="contact.title"
        class="d-none"
      >
        {{ contact.title }}
      </p>
      <p>{{ contact.room }}</p>
      <div
        v-if="showControls && (!user || !user.supereasymode)"
        class="mute-control"
        @click="muteMic"
      >
        <svg-icon :icon="micMuted ? 'SvgMicMute' : 'SvgMic'" />
      </div>
      <div
        v-if="showControls"
        class="btn-container"
      >
        <form-button
          type="danger"
          icon="SvgCall"
          rounded
          label="Cancel"
          @onClick="endCall"
        />
      </div>
      <div class="accepting">
        <svg-icon
          class="icon loader"
          icon="SvgLoadingB"
        />
        <h6 v-if="myEndPoint">
          {{ `${$t('APP_TEXT_ENDPOINT')}: ${myEndPoint}` }}
        </h6>
        <h6 :class="{'m-0': myEndPoint}">
          {{ $t('APP_TEXT_JOINIG_MEETING') }}
        </h6>
      </div>
    </div>
  </div>
</template>

<script>
import outgoing from '@/app/outgoing';
import ContactLiteCard from '@/components/ContactLiteCard';
export default {
  name: 'Outgoing',
  components: { ContactLiteCard },
  extends: outgoing
};
</script>

<style lang="scss" scoped>
</style>
